import React from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { connectPageService } from "../../../../application/domain/base/base-application-service";

import {
  ProcManagementPlacesListService,
  ContextProps,
} from "../../../../application/service/proc-management/place-list";
import { useAuthContextV2 } from "../../../../auth-state";
import { PortalTemplate } from "../../../template/portal/default-template";
import { ProcManagementR } from "../route";
import { Content } from "../../../organisms/proc-management/place-list";
import { parseQueryOfLocation } from "../../../../utils/url-utils";
import { TtzkPortalR } from "../../ttzk-portal/route";

const ProcManagementPlaceList: React.FC<ContextProps> = ({
  fetchPlacesByOrgId,
  places,
  paging,
}) => {
  const location = useLocation();
  const page = parseQueryOfLocation(location).page;
  const pageNum =
    Number.isInteger(Number(page)) && Number(page) > 0
      ? Number(page)
      : undefined;
  const { auth } = useAuthContextV2();
  const orgId = auth.data?.orgId;

  React.useEffect(() => {
    if (typeof orgId === "string") {
      fetchPlacesByOrgId(orgId, pageNum);
    }
  }, [fetchPlacesByOrgId, orgId, pageNum]);

  const history = useHistory();
  const handleRowClick = React.useCallback(
    ({ placeId }: { orgId: string; placeId: string }) => {
      history.push(ProcManagementR.PlaceDetail.link({ placeId }));
    },
    [history],
  );
  const handlePageClick = React.useCallback(
    ({ page }: { page: number }) => {
      history.push(ProcManagementR.PlaceList.link({ page }));
    },
    [history],
  );

  return (
    <PortalTemplate
      breadcrumbs={[
        { to: TtzkPortalR.Home.link({}), title: "Graffer ポータル" },
        { to: ProcManagementR.PlaceList.link({}), title: "場所マスタ" },
      ]}
    >
      {typeof orgId === "string" && (
        <Content
          places={places}
          paging={paging}
          orgId={orgId}
          onPageClick={handlePageClick}
          onRowClick={handleRowClick}
        />
      )}
    </PortalTemplate>
  );
};

export const ProcManagementPlaceListContainer = connectPageService(
  ProcManagementPlaceList,
  () => new ProcManagementPlacesListService(),
);

export const RedirectToProcManagementPlaceListContainer: React.FC = () => {
  return <Redirect to={ProcManagementR.PlaceList.link({})} />;
};
